/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { appendMetadataWithIndex } from 'ml-portals-util-react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import '@xengage/gw-platform-translations';
import metadata from './MLPAUMBTermMultipleOptComponent.metadata.json5';

function MLPAUMBTermMultipleOptComponent(props) {
    const {
        coverage,
        hasMultipleOptions,
        getOptionName,
        hasNoOptions,
        isYesNoOption,
        term,
        covIndex,
        termIndex,
        className: parentClass
    } = props;

    const { refreshData } = useDataRefresh();

    const updateTermInput = () => {
        term.applyNewValue();
    };

    const setInputTermVal = (value) => {
        term.newValue = value;
        refreshData();
    }

    const formatOptionAvailableVals = useCallback((options) => {
        if (!options) return [];
        return options.map((opt) => ({
            code: opt.code || opt.name,
            name: {
                id: opt.code,
                defaultMessage: opt.name
            }
        }));
    }, []);

    const multipleOptionTermChanged = useCallback((selectedOption, termParam) => {
        termParam.value = selectedOption;
    }, []);

    const inputTermBlur = useCallback((element, termFormObj) => {
        termFormObj.model.value = termFormObj.value;
    }, []);


    const resolvers = {};


    const overrides = {
        [`dateTerm${covIndex}${termIndex}`]: {
            visible: term.hasOptions && term.options.length === 0 && !term.readOnly,
            label: term.name,
            hideLabel: true
        },
        [`yesNoRadioButton${covIndex}${termIndex}`]: {
            value: term.value,
            availableValues: formatOptionAvailableVals(term.options),
            visible: isYesNoOption(term),
            onValueChange: multipleOptionTermChanged,
            path: term,
            label: term.name,
            hideLabel: true,
            className: parentClass
        },
        [`selectContainer${covIndex}${termIndex}`]: {
            visible: hasMultipleOptions(term) && !isYesNoOption(term) && term.isEditable_ML,
            label: term.name,
            hideLabel: true
        },
        [`termSelect${covIndex}${termIndex}`]: {
            value: term.value,
            availableValues: formatOptionAvailableVals(term.options),
            onValueChange: multipleOptionTermChanged,
            path: term,
            label: term.name,
            hideLabel: true
        },
        [`inputReadonly${covIndex}${termIndex}`]: {
            visible: hasMultipleOptions(term) && !isYesNoOption(term) && !term.isEditable_ML,
            value: getOptionName(term),
            label: term.name,
            hideLabel: true
        },
        [`inputNonReadonly${covIndex}${termIndex}`]: {
            visible: hasNoOptions(term),
            value: term.newValue,
            onValueChange: setInputTermVal,
            onBlur: updateTermInput,
            path: term,
            label: term.name,
            hideLabel: true
        }
    };

    const updatedMetadata = appendMetadataWithIndex(metadata.componentContent, `${covIndex}${termIndex}`);

    return <MetadataContent uiProps={updatedMetadata} overrideProps={overrides} {...resolvers} />;
}

MLPAUMBTermMultipleOptComponent.propTypes = {
    coverage: PropTypes.shape({}),
    editMode: PropTypes.bool,
    getChosenTermValue: PropTypes.func,
    hasSingleOption: PropTypes.func,
    getSingleOption: PropTypes.func,
    isYesNoOption: PropTypes.func,
    hasMultipleOptions: PropTypes.func,
    getOptionName: PropTypes.func,
    hasNoOptions: PropTypes.func,
    term: PropTypes.shape({}),
    covIndex: PropTypes.number,
    termIndex: PropTypes.number
};

export default MLPAUMBTermMultipleOptComponent;
